<script setup lang="ts">
import { NavigationMenuLink } from '../navigation-menu'
import { useMediaQuery } from '../utils/use-media-query'

defineProps<{
  url?: string
}>()

const isDesktop = useMediaQuery('md')
</script>

<template>
  <li v-if="isDesktop"
      class="relative flex cursor-pointer select-none items-center text-sm outline-none transition-colors focus:bg-primary-200 hover:bg-primary-200 focus:text-accent-foreground font-heading text-heading-2xs data-[disabled]:pointer-events-none data-[disabled]:opacity-50">
    <NavigationMenuLink :href="url"
                        class="w-full h-full px-4 py-3 text-heading-2xs border-none focus-visible:outline-offset-[-3px]">
      <slot />
    </NavigationMenuLink>
  </li>
  <NavigationMenuLink v-else
                      :href="url"
                      class="px-4 py-3 font-button text-heading-2xs border-none [&amp;:not(:first-child)]:border-t md:[&amp;:not(:first-child)]:border-t-0 md:[&amp;:last-child]:border-b md:p-4 focus-visible:outline-offset-[-3px]">
    <slot />
  </NavigationMenuLink>
</template>
